// Each shape is drawn in white on a 1000x600 design canvas, then sampled
// into particle targets. Brighter pixels attract more particles, so solid
// fills read as dense areas and faint fills as a light haze.

export const DESIGN_W = 1000;
export const DESIGN_H = 600;

const LOGO_PATH =
	"M66.2234 2.0274C63.6358 0.927905 60.7911 0.52332 57.8208 0.52332H53.5778C45.6691 0.52332 37.7603 0.52332 29.8516 0.52332C29.4302 0.52332 29.0064 0.52332 28.5898 0.562962C23.7902 1.02934 21.9489 4.02002 21.9489 7.66013C21.9489 9.96055 21.9791 11.3655 21.9791 13.4141C21.5263 13.055 21.2546 12.8498 20.9926 12.6306C16.5806 8.90731 12.1706 5.18247 7.76264 1.45608C6.66145 0.52332 5.43106 0.21434 4.08114 0.798483C2.76986 1.3663 2.52596 2.50544 2.52958 3.77517C2.54769 9.27731 2.53683 14.7794 2.53683 20.2816V21.5198H8.07416V8.54975C8.46899 8.86922 8.71772 9.06277 8.95679 9.26681C13.2698 12.9582 17.582 16.6504 21.8933 20.3434C22.1533 20.5784 22.4301 20.7954 22.7216 20.9928C23.7685 21.6609 24.895 21.8148 26.0385 21.2831C27.1819 20.7515 27.4971 19.7581 27.5019 18.6283C27.5091 17.0647 27.5019 15.5012 27.5091 13.9388C27.5091 13.617 27.549 13.294 27.5611 13.1226H30.8948C33.8736 13.1226 36.8523 13.1226 39.8299 13.1284C40.2817 13.1285 40.7326 13.1703 41.1762 13.2532C41.9791 13.4083 42.3957 13.9271 42.4404 14.706C42.4875 15.5105 42.1578 16.1389 41.338 16.3815C40.8107 16.527 40.2647 16.5993 39.7164 16.596C36.7376 16.6158 33.7589 16.603 30.7813 16.6077C30.4432 16.6077 30.1051 16.6485 29.8588 16.6636C29.6994 18.3496 29.5533 19.9073 29.4012 21.535C33.2505 21.535 37.3317 21.6656 41.3996 21.4942C44.8226 21.3496 47.1856 19.3838 47.7821 16.659C48.7118 12.4161 46.3851 9.13856 41.8946 8.82841C38.0936 8.56607 34.2624 8.70132 30.4432 8.65585C29.9906 8.66883 29.5377 8.64777 29.0885 8.59289C28.2795 8.45997 27.8364 7.95395 27.817 7.16459C27.7977 6.34843 28.1793 5.76545 29.045 5.60688C29.4592 5.53783 29.8793 5.50776 30.2995 5.5171C38.0586 5.51244 45.818 5.51244 53.5778 5.5171H57.3885C58.1061 5.51227 58.8234 5.54848 59.5365 5.62554C62.892 6.00331 65.3866 7.88399 65.7488 10.2707C66.1569 12.9524 64.3373 15.2505 61.0398 16.1716C58.6732 16.8339 56.1122 16.5552 53.5766 16.5843H53.4933V15.4475C53.4933 13.6333 53.4848 11.8202 53.4933 10.0072C53.4933 9.24582 53.2313 8.69549 52.3655 8.66867C51.2668 8.63486 50.162 8.61271 49.0656 8.67684C48.0622 8.7363 47.6879 9.62709 48.2614 10.4433C50.9106 14.2105 50.1269 18.6434 46.3368 21.3449C46.3006 21.3706 46.3042 21.4464 46.2764 21.5443C46.437 21.5571 46.5891 21.5805 46.7425 21.5805C49.0197 21.5805 51.297 21.6014 53.5742 21.5944C55.1559 21.5944 56.8584 21.5781 58.4402 21.5501C60.0741 21.5295 61.6998 21.3221 63.2832 20.9322C68.9932 19.4654 72.4465 16.4922 73.072 12.015C73.6817 7.66596 71.4359 4.24155 66.2234 2.0274Z";

function rr(ctx, x, y, w, h, r) {
	ctx.beginPath();
	ctx.roundRect(x, y, w, h, r);
}

function fillRect(ctx, x, y, w, h, r, alpha = 1) {
	ctx.globalAlpha = alpha;
	rr(ctx, x, y, w, h, r);
	ctx.fill();
	ctx.globalAlpha = 1;
}

function strokeRect(ctx, x, y, w, h, r, width = 5) {
	ctx.lineWidth = width;
	rr(ctx, x, y, w, h, r);
	ctx.stroke();
}

function dot(ctx, x, y, r, alpha = 1) {
	ctx.globalAlpha = alpha;
	ctx.beginPath();
	ctx.arc(x, y, r, 0, Math.PI * 2);
	ctx.fill();
	ctx.globalAlpha = 1;
}

function logo(ctx) {
	// Path box is roughly x 2.5–73, y 0.5–21.6.
	const s = 12;
	ctx.save();
	ctx.translate(500 - 37.8 * s, 300 - 11 * s);
	ctx.scale(s, s);
	ctx.fill(new Path2D(LOGO_PATH));
	ctx.restore();
}

function website(ctx) {
	strokeRect(ctx, 70, 40, 860, 520, 26, 6);
	ctx.lineWidth = 4;
	ctx.beginPath();
	ctx.moveTo(70, 108);
	ctx.lineTo(930, 108);
	ctx.stroke();
	dot(ctx, 112, 74, 9);
	dot(ctx, 142, 74, 9);
	dot(ctx, 172, 74, 9);
	strokeRect(ctx, 330, 56, 340, 36, 18, 3);

	// Headline, copy, button
	fillRect(ctx, 120, 160, 390, 38, 10);
	fillRect(ctx, 120, 212, 300, 38, 10);
	fillRect(ctx, 120, 278, 350, 12, 6, 0.35);
	fillRect(ctx, 120, 302, 300, 12, 6, 0.35);
	fillRect(ctx, 120, 342, 170, 52, 26);

	// Hero image
	fillRect(ctx, 570, 150, 310, 250, 18, 0.18);
	strokeRect(ctx, 570, 150, 310, 250, 18, 4);
	ctx.lineWidth = 5;
	ctx.beginPath();
	ctx.moveTo(590, 375);
	ctx.lineTo(680, 270);
	ctx.lineTo(740, 330);
	ctx.lineTo(790, 285);
	ctx.lineTo(860, 375);
	ctx.stroke();
	dot(ctx, 810, 205, 22, 0.9);

	// Cards
	[120, 395, 670].forEach((x) => {
		strokeRect(ctx, x, 430, 210, 96, 14, 4);
		fillRect(ctx, x + 22, 452, 90, 14, 7, 0.9);
		fillRect(ctx, x + 22, 480, 160, 9, 4, 0.3);
		fillRect(ctx, x + 22, 500, 120, 9, 4, 0.3);
	});
}

function app(ctx) {
	strokeRect(ctx, 360, 20, 280, 560, 46, 7);
	fillRect(ctx, 455, 40, 90, 22, 11);

	fillRect(ctx, 392, 92, 130, 14, 7, 0.6);
	fillRect(ctx, 392, 114, 180, 24, 8);

	strokeRect(ctx, 392, 158, 102, 84, 14, 3);
	strokeRect(ctx, 506, 158, 102, 84, 14, 3);
	fillRect(ctx, 408, 196, 52, 26, 6);
	fillRect(ctx, 522, 196, 66, 26, 6);
	fillRect(ctx, 408, 174, 60, 8, 4, 0.4);
	fillRect(ctx, 522, 174, 60, 8, 4, 0.4);

	[52, 74, 60, 96, 84, 120, 138].forEach((h, i) => {
		fillRect(ctx, 398 + i * 30, 400 - h, 18, h, 5, 0.55 + i * 0.06);
	});

	[420, 466].forEach((y) => {
		dot(ctx, 410, y + 16, 14, 0.8);
		fillRect(ctx, 434, y + 6, 120, 9, 4, 0.7);
		fillRect(ctx, 434, y + 22, 80, 8, 4, 0.3);
	});

	ctx.lineWidth = 3;
	ctx.beginPath();
	ctx.moveTo(380, 526);
	ctx.lineTo(620, 526);
	ctx.stroke();
	[420, 473, 527, 580].forEach((x, i) => dot(ctx, x, 550, 9, i === 0 ? 1 : 0.45));

	// A notification popping out of the phone
	fillRect(ctx, 600, 120, 290, 76, 22, 0.22);
	strokeRect(ctx, 600, 120, 290, 76, 22, 4);
	dot(ctx, 640, 158, 18);
	fillRect(ctx, 672, 142, 170, 13, 6);
	fillRect(ctx, 672, 164, 120, 10, 5, 0.4);

	// And a chart card on the other side
	fillRect(ctx, 110, 330, 270, 150, 22, 0.16);
	strokeRect(ctx, 110, 330, 270, 150, 22, 4);
	ctx.lineWidth = 6;
	ctx.lineJoin = "round";
	ctx.beginPath();
	ctx.moveTo(135, 450);
	ctx.lineTo(190, 420);
	ctx.lineTo(240, 432);
	ctx.lineTo(290, 380);
	ctx.lineTo(355, 360);
	ctx.stroke();
}

function ai(ctx) {
	const layers = [
		{ x: 170, n: 3 },
		{ x: 390, n: 5 },
		{ x: 610, n: 5 },
		{ x: 830, n: 2 },
	];
	const nodes = layers.map(({ x, n }) =>
		Array.from({ length: n }, (_, i) => ({ x, y: 300 + (i - (n - 1) / 2) * 105 }))
	);
	ctx.lineWidth = 2.5;
	for (let l = 0; l < nodes.length - 1; l++) {
		nodes[l].forEach((a) =>
			nodes[l + 1].forEach((b) => {
				ctx.globalAlpha = 0.28;
				ctx.beginPath();
				ctx.moveTo(a.x, a.y);
				ctx.lineTo(b.x, b.y);
				ctx.stroke();
			})
		);
	}
	ctx.globalAlpha = 1;
	nodes.flat().forEach(({ x, y }) => {
		dot(ctx, x, y, 26, 0.25);
		ctx.lineWidth = 4;
		ctx.beginPath();
		ctx.arc(x, y, 26, 0, Math.PI * 2);
		ctx.stroke();
		dot(ctx, x, y, 11);
	});

	// A spark at the output
	const sx = 930;
	const sy = 300;
	ctx.beginPath();
	ctx.moveTo(sx, sy - 52);
	ctx.quadraticCurveTo(sx + 6, sy - 6, sx + 52, sy);
	ctx.quadraticCurveTo(sx + 6, sy + 6, sx, sy + 52);
	ctx.quadraticCurveTo(sx - 6, sy + 6, sx - 52, sy);
	ctx.quadraticCurveTo(sx - 6, sy - 6, sx, sy - 52);
	ctx.fill();
}

function seo(ctx) {
	ctx.lineCap = "round";
	ctx.lineWidth = 16;
	ctx.beginPath();
	ctx.arc(330, 270, 170, 0, Math.PI * 2);
	ctx.stroke();
	dot(ctx, 330, 270, 160, 0.1);
	ctx.lineWidth = 40;
	ctx.beginPath();
	ctx.moveTo(458, 398);
	ctx.lineTo(560, 500);
	ctx.stroke();

	// Rising bars inside the lens
	[60, 95, 135, 185].forEach((h, i) => {
		fillRect(ctx, 236 + i * 52, 350 - h, 32, h, 6, 0.55 + i * 0.15);
	});
	ctx.lineWidth = 6;
	ctx.beginPath();
	ctx.moveTo(230, 250);
	ctx.lineTo(300, 210);
	ctx.lineTo(350, 222);
	ctx.lineTo(430, 150);
	ctx.stroke();

	ctx.font = "800 250px 'Bricolage Grotesque', Arial, sans-serif";
	ctx.textBaseline = "middle";
	ctx.fillText("#1", 600, 290);
}

function strategy(ctx) {
	// Week columns
	ctx.lineWidth = 2;
	for (let i = 0; i <= 8; i++) {
		ctx.globalAlpha = 0.18;
		ctx.beginPath();
		ctx.moveTo(150 + i * 95, 60);
		ctx.lineTo(150 + i * 95, 540);
		ctx.stroke();
	}
	ctx.globalAlpha = 1;
	const bars = [
		[0, 2],
		[1.4, 3.2],
		[3, 5.6],
		[5, 7.2],
		[6.6, 8],
	];
	bars.forEach(([a, b], i) => {
		const y = 100 + i * 92;
		fillRect(ctx, 150 + a * 95, y, (b - a) * 95, 46, 23, 0.95 - i * 0.08);
		fillRect(ctx, 60, y + 16, 60, 14, 7, 0.35);
	});

	// Milestones and today
	[[2, 78], [5.6, 78], [8, 78]].forEach(([w, y]) => {
		const x = 150 + w * 95;
		ctx.beginPath();
		ctx.moveTo(x, y - 18);
		ctx.lineTo(x + 18, y);
		ctx.lineTo(x, y + 18);
		ctx.lineTo(x - 18, y);
		ctx.fill();
	});
	ctx.lineWidth = 5;
	ctx.setLineDash([14, 12]);
	ctx.beginPath();
	ctx.moveTo(150 + 4.3 * 95, 50);
	ctx.lineTo(150 + 4.3 * 95, 560);
	ctx.stroke();
	ctx.setLineDash([]);
}

export const SHAPES = { logo, website, app, ai, seo, strategy };

/**
 * Samples `count` points from a shape fitted into a box of the given CSS
 * size. Returns a Float32Array of x,y pairs in box coordinates.
 */
export function sampleShape(name, boxW, boxH, count) {
	const scale = Math.min(boxW / DESIGN_W, boxH / DESIGN_H);
	const w = Math.max(1, Math.round(DESIGN_W * scale));
	const h = Math.max(1, Math.round(DESIGN_H * scale));
	const canvas = document.createElement("canvas");
	canvas.width = w;
	canvas.height = h;
	const ctx = canvas.getContext("2d", { willReadFrequently: true });
	ctx.scale(scale, scale);
	ctx.fillStyle = "#fff";
	ctx.strokeStyle = "#fff";
	SHAPES[name](ctx);

	const { data } = ctx.getImageData(0, 0, w, h);
	const cand = [];
	for (let i = 3; i < data.length; i += 4) {
		if (data[i] > 24) cand.push((i - 3) >> 2);
	}
	const out = new Float32Array(count * 2);
	const ox = (boxW - w) / 2;
	const oy = (boxH - h) / 2;
	if (!cand.length) return out;
	let n = 0;
	let guard = 0;
	while (n < count && guard < count * 60) {
		guard++;
		const p = cand[(Math.random() * cand.length) | 0];
		if (Math.random() * 255 > data[p * 4 + 3]) continue;
		out[n * 2] = ox + (p % w) + Math.random();
		out[n * 2 + 1] = oy + ((p / w) | 0) + Math.random();
		n++;
	}
	return out;
}
